import { useCallback } from 'react';

import { usePrimaryProduct, useUser } from '../store/bootstrap';

import { type onError, logException } from './log-exception';

/**
 * Returns a callback that logs exceptions to Sentry. The callback returned never mutates,
 * hence it is safe to use in dependency arrays.
 */
export const useLogException = (): ((error: any) => Promise<void>) => {
	const [primaryProduct] = usePrimaryProduct();
	const [user] = useUser();

	// Store data required for logging exceptions in refs to prevent re-renders
	return useCallback(
		async (error) => await logException(error, user?.id, primaryProduct),
		[primaryProduct, user?.id],
	) satisfies onError;
};
